import { render, staticRenderFns } from "./InspectionModalRemarks.vue?vue&type=template&id=1ef2c106&scoped=true&"
import script from "./InspectionModalRemarks.vue?vue&type=script&lang=ts&"
export * from "./InspectionModalRemarks.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionModalRemarks.vue?vue&type=style&index=0&id=1ef2c106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef2c106",
  null
  
)

export default component.exports